import request from '@/router/axios'
import env from '@/config/env'

/**
 * 修改评价维度
 */
export const modifyEvaluation = (params) => {
  return request({
    url: env.ferryUrl + '/evaluation/save',
    method: 'POST',
    data: params
  })
}
/**
 * 修改投诉
 */
export const modifyComplaint = (params) => {
  return request({
    url: env.ferryUrl + '/complaint-suggestion/add',
    method: 'POST',
    data: params
  })
}

// 评价分页
export const getEvaluateList = (params) => {
  return request({
    url: env.ferryUrl + '/evaluation/merchant-statistics/page',
    method: 'GET',
    params: {
      ...params
    }
  })
}
// 供应商配置
export const getMerchantConfig = (params) => {
  return request({
    url: env.ferryUrl + '/evaluation/merchant',
    method: 'GET',
    params: {
      ...params
    }
  })
}
// 供应商线路配置
export const getEvaluateListByLine = (params) => {
  return request({
    url: env.ferryUrl + '/evaluation/merchant-line/page',
    method: 'POST',
    data: params
  })
}
// 供应商历史配置
export const getMerchantHistory = (params) => {
  return request({
    url: env.ferryUrl + '/evaluation/merchant-history',
    method: 'POST',
    data: params
  })
}
// 获取评价常量
export const getConst = () => {
  return request({
    url: env.ferryUrl + '/complaint-suggestion/constants',
    method: 'get'
  })
}
// 获取全局配置
export const getGlobalConfig = () => {
  return request({
    url: env.ferryUrl + '/evaluation/top',
    method: 'get'
  })
}
// 获取投诉建议详情
export const getDetail = (params) => {
  return request({
    url: env.ferryUrl + '/complaint-suggestion/detail',
    method: 'get',
    params
  })
}
// 获取投诉建议详情
export const getComplaintList = (params) => {
  return request({
    url: env.ferryUrl + '/complaint-suggestion/page',
    method: 'POST',
    data: params
  })
}
/**
 * 提交处理进程
 */
export const modifyProcess = (params) => {
  return request({
    url: env.ferryUrl + '/complaint-suggestion/process',
    method: 'POST',
    data: params
  })
}

// 完结编辑内容
export const editComplaint = (params) => {
  return request({
    url: env.ferryUrl + '/complaint-suggestion/edit',
    method: 'POST',
    data: params
  })
}

/**
 * 获取供应商
 */
export const getMerchantListBy = () => {
  return request({
    url: env.ferryUrl + '/merchant/idNameList',
    method: 'GET'
  })
}
/**
 * 通过供应商获取路线
 */
export const getLineByMerchant = (params) => {
  return request({
    url: env.ferryUrl + '/lineAdmin/getLineByMerchantIds',
    method: 'GET',
    params
  })
}
/**
 * 通过供应商获取用户
 */
export const getUserByMerchant = (params) => {
  return request({
    url: env.ferryUrl + '/user/getByMerchantId',
    method: 'GET',
    params
  })
}
/**
 * 通过供应商获取具有处理权限的用户
 */
export const getUserByMerchantWith = (params) => {
  return request({
    url: env.ferryUrl + '/user/getComplaintHumanByMerchantId',
    method: 'GET',
    params
  })
}
/**
 * 是否显示
 */
export const changeShow = (params) => {
  return request({
    url: env.ferryUrl + '/complaint-suggestion/display',
    method: 'GET',
    params
  })
}
// 设置平台通知人
export const setPlatNoticeUser = (params) => {
  return request({
    url: env.ferryUrl + '/complaint-suggestion/setListener',
    method: 'POST',
    data: params
  })
}
// 获取平台通知人
export const getPlatUser = (params) => {
  return request({
    url: env.ferryUrl + '/complaint-suggestion/getListener',
    method: 'GET',
    params
  })
}
// 获取消息列表
export const getNoticeListDesc = (params) => {
  return request({
    url: env.ferryUrl + '/boss-m-push-record/getByUserIdDesc',
    method: 'GET',
    params
  })
}
// 获取未读消息列表
export const getNoticeListUnRead = (params) => {
  return request({
    url: env.ferryUrl + '/boss-m-push-record/getByUserIdUnreadAsc',
    method: 'GET',
    params
  })
}
// 阅读消息
export const readNotice = (params) => {
  return request({
    url: env.ferryUrl + '/boss-m-push-record/read',
    method: 'GET',
    params
  })
}

/**
 * 数报中心 start
 */

// 平台运营数据汇总
export const platformSummary = (params) => {
  return request({
    url: env.ferryUrl + '/operation-report/v2/platform-summary',
    method: 'GET',
    params
  })
}
// 地州经营概况
export const platformState = (params) => {
  return request({
    url: env.ferryUrl + '/operation-report/state-summary',
    method: 'GET',
    params
  })
}
// 交易数据汇总
export const transactionSummary = (params) => {
  return request({
    url: env.ferryUrl + '/operation-report/v2/state-revenue-summary',
    method: 'GET',
    params
  })
}

// 保险数据汇总
export const insuranceSummary = (params) => {
  return request({
    url: env.ferryUrl + '/operation-report/insurance-summary',
    method: 'GET',
    params
  })
}
// 渠道新增用户运营数据汇总
export const userChannel = (params) => {
  return request({
    url: env.ferryUrl + '/operation-report/user-channel-summary',
    method: 'GET',
    params
  })
}
// 用户转化运营数据汇总
export const userSummary = (params) => {
  return request({
    url: env.ferryUrl + '/user/operationReportUserAreaConversionSummary',
    method: 'POST',
    data: params
  })
}
// 运营情况统计
export const situationSummary = (params) => {
  return request({
    url: env.ferryUrl + '/operation-report/situation-summary',
    method: 'GET',
    params
  })
}
// 用户地区数据
export const userAreaSummary = (params) => {
  return request({
    url: env.ferryUrl + '/user/userArea',
    method: 'POST',
    data: params
  })
}
// 用户地区数据指标枚举
export const userTargetFetch = (params) => {
  return request({
    url: env.ferryUrl + '/user/zhiBiao',
    method: 'POST',
    data: params
  })
}
// 用户地区数据地州枚举
export const userAreaFetch = (params) => {
  return request({
    url: env.ferryUrl + '/user/area',
    method: 'POST',
    data: params
  })
}
// 运营情况统计
export const marketSummary = (params) => {
  return request({
    url: env.ferryUrl + '/operation-report/market-summary',
    method: 'GET',
    params
  })
}
/**
 * 数报中心 end
 */

// 运营公告分页
export const announcementPage = (params) => {
  return request({
    url: env.ferryUrl + '/announcement/page',
    method: 'POST',
    data: params
  })
}
// 保存运营公告
export const announcementSave = (params) => {
  return request({
    url: env.ferryUrl + '/announcement/save',
    method: 'POST',
    data: params
  })
}
// 公告批量操作
export const batchOperate = (params) => {
  return request({
    url: env.ferryUrl + '/announcement/batchOperate',
    method: 'POST',
    data: params
  })
}
// 公告批量操作
export const announcementDetail = (params) => {
  return request({
    url: env.ferryUrl + '/announcement/detail',
    method: 'GET',
    params
  })
}
// 公告枚举获取
export const announcementEnum = () => {
  return request({
    url: env.ferryUrl + '/announcement/enum',
    method: 'GET'
  })
}
// 用户获取公告
export const announcementUserPage = (params) => {
  return request({
    url: env.ferryUrl + '/announcement/userPage',
    method: 'GET',
    params
  })
}
// 确认阅读公告
export const announcementConfirm = (params) => {
  return request({
    url: env.ferryUrl + '/announcement/confirm',
    method: 'PUT',
    params
  })
}
// 确认阅读公告
export const popupList = () => {
  return request({
    url: env.ferryUrl + '/popup/list',
    method: 'GET'
  })
}
// 退款记录分页接口
export const refundFailPage = (params) => {
  return request({
    url: env.ferryUrl + '/refund/page',
    method: 'POST',
    data: params
  })
}
// 申请退款
export const refundApply = (params) => {
  return request({
    url: env.ferryUrl + `/refund/apply/${params}`,
    method: 'GET'
  })
}
// 更新退款状态
export const updateRefundStatus = (params) => {
  return request({
    url: env.ferryUrl + '/refund/revised-data',
    method: 'POST',
    data: params
  })
}

/**
 * 下单立减 start
 */
// 获取下单立减列表
export const getReduceList = (params) => {
  return request({
    url: env.ferryUrl + '/activityLiJian/page',
    method: 'POST',
    data: params
  })
}
// 获取下单立减使用数据
export const getData = (params) => {
  return request({
    url: env.ferryUrl + '/activityLiJian/use/page',
    method: 'POST',
    data: params
  })
}
// 获取下单立减详情
export const getAcDetail = (params) => {
  return request({
    url: env.ferryUrl + `/activityLiJian/${params.no}`,
    method: 'GET',
    params
  })
}
// 获取下单立减详情
export const changeState = (params) => {
  // const {state, no, remark} = params
  return request({
    url: env.ferryUrl + '/activityLiJian/shenHeShangXiaJia',
    method: 'POST',
    data: params
  })
}
// 新增优惠
export const addReduce = (params) => {
  return request({
    url: env.ferryUrl + '/activityLiJian',
    method: 'PUT',
    data: params
  })
}
// 编辑优惠
export const editReduce = (params) => {
  return request({
    url: env.ferryUrl + '/activityLiJian',
    method: 'POST',
    data: params
  })
}
// 下单立减关联渠道列表
export const getChannelManageList = (params) => {
  return request({
    url: env.ferryUrl + '/channelManage/list',
    method: 'POST'
  })
}

/**
 * 下单立减 end
 */

// 卖券分页接口
export const salePage = (params) => {
  return request({
    url: env.ferryUrl + '/receive/coupon/sale-coupon-record',
    method: 'POST',
    data: params
  })
}

// 设置草稿缓存，存活时间7天
export const setDraft = (params) => {
  return request({
    url: env.ferryUrl + '/draft/set',
    method: 'POST',
    data: params
  })
}
// 获取草稿缓存
export const getDraft = (params) => {
  return request({
    url: env.ferryUrl + '/draft/get',
    method: 'GET',
    params
  })
}
// 帮助中心标签配置全部数据
export const helpLabelAll = (params) => {
  return request({
    url: env.ferryUrl + '/helpCenter/label-all',
    method: 'GET',
    params
  })
}
// 文章分页
export const articlePage = (params) => {
  return request({
    url: env.ferryUrl + '/helpCenter/article-page',
    method: 'POST',
    data: params
  })
}
// 删除文章
export const articleDelete = (params) => {
  return request({
    url: env.ferryUrl + `/helpCenter/article-delete/${params}`,
    method: 'GET'
  })
}
// 文章详情接口
export const articleInfo = (params) => {
  return request({
    url: env.ferryUrl + `/helpCenter/article-info/${params}`,
    method: 'GET'
  })
}
// 保存或编辑文章
export const articleSave = (data) => {
  return request({
    url: env.ferryUrl + '/helpCenter/article-save',
    method: 'POST',
    data
  })
}
// 保存或编辑标签配置
export const labelSave = (data) => {
  return request({
    url: env.ferryUrl + '/helpCenter/label-save',
    method: 'POST',
    data
  })
}
// 所有文章
export const articleAll = () => {
  return request({
    url: env.ferryUrl + '/helpCenter/article-all',
    method: 'GET'
  })
}
// 根据类型分页文章
export const typeArticlePage = (data) => {
  return request({
    url: env.ferryUrl + '/helpCenter/type-article-page',
    method: 'POST',
    data
  })
}
// 检索文章
export const articleSearch = (params) => {
  return request({
    url: env.ferryUrl + '/helpCenter/article-search',
    method: 'POST',
    data: params
  })
}
// 根据类型获取标签
export const labelType = (type) => {
  return request({
    url: env.ferryUrl + `/helpCenter/label-type/${type}`,
    method: 'GET'
  })
}
// 获取某个类型下的标签项
export const textTypeLabel = (id) => {
  return request({
    url: env.ferryUrl + `/helpCenter/label/${id}`,
    method: 'GET'
  })
}
// 删除标签配置
export const labelDelete = (id) => {
  return request({
    url: env.ferryUrl + `/helpCenter/label-delete/${id}`,
    method: 'GET'
  })
}
// 上传文件接口
export const fileUpload = (data) => {
  return request({
    url: env.ferryUrl + '/oss/uploadV2',
    method: 'POST',
    data
  })
}
// 根据手机号获取用户全部信息
export const userInfoTotal = (param, type = '') => {
  return request({
    url:
      env.ferryUrl +
      (type === 'userId' ? `/user/info/total?userId=${param}` : `/user/info/total/${param}`),
    method: 'GET'
  })
}
// 用户订单分页信息
export const userInfoOrderPage = (data) => {
  return request({
    url: env.ferryUrl + '/user/info/order/page',
    method: 'POST',
    data
  })
}
// 用户优惠券分页
export const userCouponPage = (data) => {
  return request({
    url: env.ferryUrl + '/user/info/coupon/page',
    method: 'POST',
    data
  })
}
// 用户投诉建议分页
export const userComplaintPage = (data) => {
  return request({
    url: env.ferryUrl + '/user/info/complaint-suggestion/page',
    method: 'POST',
    data
  })
}
// 用户短信、微信通知、开票记录综合分页
export const userMessagePage = (data) => {
  return request({
    url: env.ferryUrl + '/user/info/message/page',
    method: 'POST',
    data
  })
}
// 用户联系人分页信息
export const userPassengerPage = (data) => {
  return request({
    url: env.ferryUrl + '/user/info/passenger/page',
    method: 'POST',
    data
  })
}
// 根据订单id获取百望发票链接
export const userInvoiceUrl = (orderId) => {
  return request({
    url: env.ferryUrl + `/user/info/invoice-url/${orderId}`,
    method: 'GET'
  })
}

// 查询当前供应商公司（供应商及其下属供应商）
export const getAllLowMerchant = () => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/getAllLowMerchant',
    method: 'GET'
  })
}
// 获取责任部门
export const queryMerchantList = () => {
  return request({
    url: env.ferryUrl + '/flightManage/queryMerchantList',
    method: 'get'
  })
}
// 获取责任部门
export const suggestionExport = (params) => {
  return request({
    url: env.ferryUrl + '/complaint-suggestion/export',
    method: 'get',
    params
  })
}
// 获取证照提醒配置
export const configList = (params) => {
  return request({
    url: env.ferryUrl + '/license-remind/config/list',
    method: 'get',
    params
  })
}
// 保存证照提醒配置
export const configSave = (params) => {
  return request({
    url: env.ferryUrl + '/license-remind/config/save',
    method: 'POST',
    data: params
  })
}
// 获取证照提醒内容
export const licenseRemind = (params) => {
  return request({
    url: env.ferryUrl + '/license-remind/popup',
    method: 'GET',
    params
  })
}
// 投诉建议详情订单信息接口
export const getComplaintSuggestionOrderInfo = (params) => {
  return request({
    url: env.ferryUrl + '/complaint-suggestion/order-info',
    method: 'GET',
    params
  })
}

// 获取key
export const getGDKey = (params) => {
  return request({
    url: env.ferryUrl + '/systemConfig/gaode',
    method: 'GET',
    params
  })
}

// Export modules
export * from './channel'
